import { Search } from "@mui/icons-material";
import { tableData } from "mock-data/appeal-process-data";
import { paymentsData } from "mock-data/payments-tableData-mock";
import { rows } from "mock-data/pcn-tableData-mock";
import { useState } from "react";
import { useNavigate } from "react-router-dom";



const SearchInput = () => {
  const [query, setQuery] = useState<string>("");
  const navigate = useNavigate();
  const submitHandler = (e: any) => {
    e.preventDefault();

    const searchResult = rows.filter((value: any) =>
      value.pcnNumer?.toLowerCase().includes(query.toLowerCase()) ||
      value.vehicleNumber?.toLowerCase().includes(query.toLowerCase())
    );

    const searchResult2 = tableData.filter((value: any) =>
      value.appealNumber?.toLowerCase().includes(query.toLowerCase())
    );

    const searchResult3 = paymentsData.filter((value: any) =>
      value.invoiceNo?.toLowerCase().includes(query.toLowerCase())
    );

    if (searchResult.length > 0) {
      return (navigate("/pcn", { replace: true }))
    } else if (searchResult2.length > 0) {
      return (navigate("/appeal-process", { replace: true }))
    } else if (searchResult3.length) {
      return (navigate("/payments", { replace: true }))
    } else {
      <p>no data fond</p>
    }
  }
  return (
    <form onSubmit={submitHandler}>
      <div className="searchHold">
        <input
          type="search"
          placeholder="Search"
          className="searchInput border-radius-4"
          onChange={(e) => setQuery(e.target.value)}
          size={40}
        />
        <Search className="searchIcon icon-color" />
      </div>
    </form>
  )
}

export default SearchInput